import { useState, useRef, useEffect, useMemo } from 'react';
import {
   Box,
   Button,
   Checkbox,
   Flex,
   Heading,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalFooter,
   ModalCloseButton,
   Table,
   Tbody,
   Td,
   Text,
   Th,
   Thead,
   Tr,
   Select,
   Input,
   VStack,
   HStack,
   Spinner,
   Alert,
   AlertIcon,
   useColorModeValue,
   FormControl,
   FormLabel,
   Divider,
   Tabs,
   TabList,
   TabPanels,
   Tab,
   TabPanel,
   Badge,
   Stack,
   useColorMode,
} from '@chakra-ui/react';
import axios from '../../../../axios';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import { DAYBOOK_TYPE } from 'constants';
import { getDaybookForPayments } from '../../../../redux/actions/daybook';
import { getSuspenseAccount } from '../../../../redux/actions/account';
import AddEditForm from 'views/admin/masters/Pages/CustomerMaster/AddEditForm';

export default function BankTransferModal({ isBankTransfer, onClose, handleBankTransfer }) {
   const dispatch = useDispatch();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const [selectedItems, setSelectedItems] = useState({});
   const [selectAll, setSelectAll] = useState(false);
   const [selectedBank, setSelectedBank] = useState('');
   const [selectedDaybook, setSelectedDaybook] = useState('');
   const suspenseAcc = useSelector((state) => state.account.suspense_list || []);
   const daybookTypeData = useSelector((state) => state.daybook?.listPayment || null);
   const [selectedFile, setSelectedFile] = useState(null);
   const [suspenseAccount, setSuspenseAccount] = useState(null);
   const [bankStatements, setBankStatements] = useState([]);
   const [distinctStatements, setDistinctStatements] = useState([]);
   const [selectedStatements, setSelectedStatements] = useState({});
   const [selectedAllStatements, setSelectedAllStatements] = useState({});
   const [isLoading, setIsLoading] = useState(false);
   const [isImporting, setIsImporting] = useState(false);
   const { user } = useUser();
   const [message, setMessage] = useState('');
   const fileInputRef = useRef(null);
   const [isOpen, setIsOpen] = useState(false);
   const [isEditMode, setIsEditMode] = useState(false);
   const [currentRow, setCurrentRow] = useState({});

   // Updated formData structure for bulk import
   const [formData, setFormData] = useState({
      companyId: parseInt(localStorage.getItem('companyId')),
      daybookId: null,
      vouchers: [], // This will contain array of VoucherAddDTO objects
   });

   const bankOptions = [
      { value: '1', label: 'SBI' },
      { value: '2', label: 'Indusnd Bank' },
      { value: '3', label: 'Fedral Bank' },
      { value: '4', label: 'ICICI Bank' },
      { value: '5', label: 'Indian Bank' },
      { value: '6', label: 'Paytm Bank' },
      { value: '7', label: 'Kalyan' },
      { value: '8', label: 'BOB Bank' },
      { value: '9', label: 'Union Bank' },
      { value: '10', label: 'Varacha Bank' },
      { value: '11', label: 'Surat Bank' },
      { value: '12', label: 'Akhand Anand Bank' },
      { value: '13', label: 'Canaera Bank' },
      { value: '14', label: 'CBI Bank' },
      { value: '15', label: 'HDFC Bank' },
      { value: '16', label: 'Axis Bank' },
      { value: '17', label: 'AU Bank' },
   ];

   const masterItems = [
      { code: 'Account', name: 'Account' },
      { code: 'Items', name: 'Item' },
      { code: 'Category', name: 'Category' },
      { code: 'Brand', name: 'Brand' },
      { code: 'Serise', name: 'Serise' },
      { code: 'Item Group', name: 'Item Group' },
      { code: 'Warehouse', name: 'Warehouse' },
      { code: 'Unit', name: 'Unit' },
      { code: 'Screen', name: 'Screen' },
      { code: 'Bank Branch', name: 'Bank Branch' },
      { code: 'Transport', name: 'Transport' },
      { code: 'Driver', name: 'Driver' },
      { code: 'Vehicle', name: 'Vehicle' },
      { code: 'Color', name: 'Color' },
      { code: 'Style', name: 'Style' },
      { code: 'Size', name: 'Size' },
   ];

   const userCompanyId = Number(user?.loginhistory?.companyId);
   const localCompanyId = Number(localStorage.getItem('companyId'));
   const validCompanyId = useMemo(() => {
      return !isNaN(userCompanyId) && userCompanyId > 0
         ? userCompanyId
         : !isNaN(localCompanyId) && localCompanyId > 0
         ? localCompanyId
         : null;
   }, [userCompanyId, localCompanyId]);

   // Function to clear all modal data
   const clearAllData = () => {
      setSelectedItems({});
      setSelectAll(false);
      setSelectedBank('');
      setSelectedDaybook('');
      setSelectedFile(null);
      setBankStatements([]);
      setDistinctStatements([]);
      setSelectedStatements({});
      setSelectedAllStatements({});
      setIsLoading(false);
      setIsImporting(false);
      setMessage('');
      setIsOpen(false);
      setIsEditMode(false);
      setCurrentRow({});
      setFormData({
         companyId: parseInt(localStorage.getItem('companyId')),
         daybookId: null,
         vouchers: [],
      });

      // Clear file input
      if (fileInputRef.current) {
         fileInputRef.current.value = '';
      }
   };

   // Modified onClose handler to clear data
   const handleModalClose = () => {
      clearAllData();
      onClose();
   };
   // Refactored Effect 1: Fetch initial data (Daybooks and Suspense Account)
   useEffect(() => {
      const fetchInitialData = async () => {
         if (validCompanyId) {
            try {
               // await dispatch(getDaybookForPayments({ type: DAYBOOK_TYPE.BANK, companyId: validCompanyId }));
               await dispatch(getSuspenseAccount({ name: 'SUSPENCE', compId: validCompanyId, page: 1, limit: 10 }));
            } catch (error) {
               console.error('Error fetching initial data:', error);
            }
         } else {
            console.warn('Skipping initial data fetch: Invalid companyId');
         }
      };

      fetchInitialData();
   }, [dispatch, validCompanyId]);

   // Refactored Effect 2: Update local suspenseAccount state when the Redux store changes
   useEffect(() => {
      const updateSuspenseAccount = async () => {
         if (suspenseAcc && suspenseAcc.length > 0) {
            setSuspenseAccount(suspenseAcc[0].id);
         } else {
            setSuspenseAccount(null);
         }
      };

      updateSuspenseAccount();
   }, [suspenseAcc]);

   const handleSave = () => {
      // Close the Add/Edit form modal
      setIsOpen(false);
      // Re-fetch the suspense account to get the newly created one
      if (validCompanyId) {
         dispatch(getSuspenseAccount({ name: 'SUSPENCE', compId: validCompanyId, page: 1, limit: 10 }));
      }
      // Give feedback to the user
      setMessage('Suspense Account created. Please try importing again.');
   };

   // Helper function to get last voucher doc number
   const getLastVoucherDocNumber = async (companyId, daybookId, txnType) => {
      try {
         const response = await axios.get(
            `/voucher/last?companyId=${companyId}&daybookId=${daybookId}&txnType=${txnType}`,
         );
         if (response.data.code === 1) {
            const docNumber = response.data.data.docNumber;
            return parseInt(docNumber) + 1;
         }
         return 1; // Default if no previous voucher
      } catch (error) {
         console.error('Error fetching last voucher:', error);
         return 1; // Default fallback
      }
   };

   // Helper function to parse date
   const parseDate = (dateStr) => {
      try {
         // Handle different date formats like "7 Apr 2022"
         const date = new Date(dateStr);
         if (isNaN(date.getTime())) {
            return new Date().toISOString().split('T')[0];
         }
         return date.toISOString().split('T')[0];
      } catch (error) {
         return new Date().toISOString().split('T')[0];
      }
   };

   // Function to create voucher object from bank statement
   const createVoucherFromStatement = async (statement, companyId, daybookId, docNumber) => {
      const hasCredit = statement.credit && parseFloat(statement.credit) > 0;
      const hasDebit = statement.debit && parseFloat(statement.debit) > 0;

      const txnType = hasCredit ? 1 : 0; // 1 for credit, 0 for debit
      const amount = hasCredit ? parseFloat(statement.credit) : parseFloat(statement.debit || 0);

      return {
         companyId: companyId,
         daybookId: daybookId,
         docNumber: docNumber.toString(),
         txnType: txnType,
         txnDate: parseDate(statement.date),
         accountId: suspenseAccount, // 325 ID with ledgre group Z
         // accountId: 325, // 325 ID with ledgre group Z
         // accountId: 1, // You may need to determine this based on your business logic
         amount: amount,
         brokerId: 0,
         supplierId: 0,
         chequeNo: null,
         transactionNo: statement.ref_no_cheque_no || '',
         bankId: 0,
         bankBranchId: 0,
         particulars: '',
         depositeDate: null,
         clearingDate: null,
         tdsApplicable: false,
         tdsAccountId: 0,
         tdsLimit: 0,
         tdsRate: 0,
         tdsCess: 0,
         tdsSurcharge: 0,
         tdsAmount: 0,
         tdsCessAmount: 0,
         tdsSurchargeAmount: 0,
         tdsHCessAmount: 0,
         tdsInterestAmount: 0,
         tdsPenaltyAmount: 0,
         tdsOthersAmount: 0,
         notes1: '',
         notes2: '',
         notes3: '',
         notes4: '',
         notes5: '',
         userNote: statement.description || '',
         taxableValue: '',
         GSTAmount: 0,
         stateOfSupply: 0,
         isRCM: false,
         GSTSubTxnType: 0,
         HSNSACId: 0,
         typeofSupply: null,
         partyBillNo: 0,
         GSTTxnType: 0,
         chequeDate: null,
         // chequeDate: statement.txn_date ? parseDate(statement.txn_date) : null,
         outAdjustments: [],
         isImported: true,
         // spId: null,
      };
   };

   const handleFileSelect = (event) => {
      const file = event.target.files[0];
      setSelectedFile(file);
      setBankStatements([]);
      setDistinctStatements([]);
      setSelectedStatements({});
      setSelectedAllStatements({});
      setMessage('');
   };

   const extractBankStatement = async () => {
      if (!selectedFile || !selectedBank) {
         setMessage('Please select both bank and file');
         return;
      }

      setIsLoading(true);
      setMessage('');

      try {
         const formData = new FormData();
         formData.append('file', selectedFile);
         formData.append('bank', selectedBank);
         formData.append('companyId', parseInt(validCompanyId));
         formData.append('accountId', parseInt(suspenseAccount));

         const response = await axios.post(`/bank-branch/extract`, formData, {
            headers: {
               'Content-Type': 'multipart/form-data',
            },
         });

         const data = response.data.data;
         setBankStatements(data.transactions || []);

         const descriptionMap = new Map();
         data.transactions?.forEach((statement, index) => {
            const desc = statement.description;
            if (!descriptionMap.has(desc)) {
               descriptionMap.set(desc, { ...statement, originalIndex: index, count: 1 });
            } else {
               descriptionMap.get(desc).count++;
            }
         });

         const distinctData = Array.from(descriptionMap.values());
         setDistinctStatements(distinctData);

         setMessage(
            `Extracted ${data.transactions?.length || 0} records, ${distinctData.length} distinct descriptions`,
         );
      } catch (error) {
         setMessage(`Error: ${error.response.data.message}`);
      } finally {
         setIsLoading(false);
      }
   };

   const toggleAllStatementSelection = (index) => {
      setSelectedAllStatements((prev) => ({
         ...prev,
         [index]: !prev[index],
      }));
   };

   const importSelectedAllStatements = async () => {
      const selectedData = bankStatements.filter((_, index) => selectedAllStatements[index]);
      if (selectedData.length === 0) {
         setMessage('Please select at least one statement to import');
         return;
      }

      if (!selectedDaybook) {
         setMessage('Please select a daybook');
         return;
      }

      setIsImporting(true);
      setMessage('');

      try {
         const companyId = parseInt(localStorage.getItem('companyId'));
         const daybookId = parseInt(selectedDaybook);

         // Improved sanitization function that handles UPI/transaction references better
         const sanitizeText = (text) => {
            if (!text) return text;
            return text
               .replace(/\n/g, ' ') // Replace newlines with space
               .replace(/\r/g, ' ') // Replace carriage returns with space
               .replace(/\s+/g, ' ') // Collapse multiple spaces to one
               .replace(/\s*-\s*/g, '-') // Remove spaces around hyphens
               .replace(/\s*\/\s*/g, '/') // Remove spaces around slashes
               .trim(); // Trim leading/trailing spaces
         };

         const creditStatements = [];
         const debitStatements = [];
         for (let i = 0; i < selectedData.length; i++) {
            const statement = { ...selectedData[i] };
            // Sanitize text fields
            if (statement.description) {
               statement.description = sanitizeText(statement.description);
            }
            if (statement.ref_no_cheque_no) {
               statement.ref_no_cheque_no = sanitizeText(statement.ref_no_cheque_no);
            }
            const hasCredit = statement.credit && parseFloat(statement.credit) > 0;
            if (hasCredit) {
               creditStatements.push(statement);
            } else {
               debitStatements.push(statement);
            }
         }
         // Create vouchers array from selected statements
         const vouchers = [];
         // Process credit statements (txnType 1)
         if (creditStatements.length > 0) {
            const creditDocNumber = (await getLastVoucherDocNumber(companyId, daybookId, 1)) || 1;
            for (let i = 0; i < creditStatements.length; i++) {
               const statement = creditStatements[i];
               const docNumber = creditDocNumber + i;

               const voucher = await createVoucherFromStatement(statement, companyId, daybookId, docNumber);
               vouchers.push(voucher);
            }
         }

         if (debitStatements.length > 0) {
            const debitDocNumber = (await getLastVoucherDocNumber(companyId, daybookId, 0)) || 1;

            for (let i = 0; i < debitStatements.length; i++) {
               const statement = debitStatements[i];
               const docNumber = debitDocNumber + i;

               const voucher = await createVoucherFromStatement(statement, companyId, daybookId, docNumber);
               vouchers.push(voucher);
            }
         }

         // Update form data with bulk import structure
         const bulkImportData = {
            // companyId: companyId,
            // daybookId: daybookId,
            vouchers: vouchers,
         };

         setFormData(bulkImportData);

         // Call bulk import API
         const response = await axios.post(`/voucher/bulk-import`, bulkImportData);

         if (response.data.code === 1) {
            setMessage(`Successfully imported ${selectedData.length} vouchers`);
            // Reset selections after successful import
            setSelectedAllStatements({});
            // Auto-extract bank statements again after successful import
            // await extractBankStatement();
         } else {
            throw new Error(response.data.message || 'Failed to import vouchers');
         }
      } catch (error) {
         setMessage(`Import Error: ${error.message}`);
         console.error('Import error:', error);
      } finally {
         setIsImporting(false);
      }
   };

   // Theme colors based on color mode
   const themeColors = {
      // Header backgrounds with premium gradients
      companyHeader: isDark
         ? 'linear-gradient(135deg, #1e3a8a 0%, #3730a3 50%, #1e40af 100%)'
         : 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 50%, #2563eb 100%)',

      accountHeader: isDark
         ? 'linear-gradient(135deg, #0f766e 0%, #115e59 50%, #134e4a 100%)'
         : 'linear-gradient(135deg, #0d9488 0%, #0f766e 50%, #14b8a6 100%)',

      // Background colors
      bgPrimary: isDark ? 'gray.900' : 'white',
      bgSecondary: isDark ? 'gray.800' : 'gray.50',
      bgTertiary: isDark ? 'gray.700' : 'gray.100',

      // Border colors - dark: gray shades, light: background shades
      borderPrimary: isDark ? 'gray.600' : 'gray.200',
      borderSecondary: isDark ? 'gray.700' : 'gray.300',

      // Text colors
      textPrimary: isDark ? 'white' : 'gray.900',
      textSecondary: isDark ? 'gray.300' : 'gray.600',
      textTertiary: isDark ? 'gray.400' : 'gray.500',

      // Interactive colors
      hoverBg: isDark ? 'gray.700' : 'gray.100',
      activeBg: isDark ? 'gray.600' : 'gray.200',

      // Status colors
      success: isDark ? 'green.500' : 'green.600',
      error: isDark ? 'red.500' : 'red.600',
      warning: isDark ? 'yellow.500' : 'yellow.600',
      info: isDark ? 'blue.500' : 'blue.600',
   };

   return (
      <Modal
         isOpen={isBankTransfer}
         onClose={handleModalClose}
         size={{ base: 'full', md: '6xl' }}
         isCentered
         scrollBehavior="inside">
         <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
         <ModalContent
            bg={themeColors.bgPrimary}
            mx={{ base: 0, md: 4 }}
            my={{ base: 0, md: 4 }}
            maxH={{ base: '100vh', md: '95vh' }}
            border="1px"
            borderColor={themeColors.borderPrimary}
            boxShadow="xl"
            borderRadius="xl"
            overflow="hidden">
            {/* Premium Header with Gradient */}
            <ModalHeader
               display="flex"
               alignItems="center"
               bg={themeColors.companyHeader}
               px={{ base: 4, md: 6 }}
               py={{ base: 4, md: 5 }}
               borderBottom="1px"
               borderColor={themeColors.borderPrimary}>
               <Heading size={{ base: 'md', md: 'lg' }} color="white" fontWeight="bold" letterSpacing="tight">
                  Bank Transfer Manager
               </Heading>
            </ModalHeader>

            <ModalCloseButton
               size="lg"
               color="white"
               _hover={{ bg: 'blackAlpha.300' }}
               _active={{ bg: 'blackAlpha.400' }}
            />

            <ModalBody px={{ base: 4, md: 6 }} py={{ base: 5, md: 6 }}>
               <VStack spacing={{ base: 5, md: 6 }} align="stretch">
                  {/* Bank Selection and File Upload Section */}
                  <Box
                     bg={themeColors.bgSecondary}
                     p={{ base: 4, md: 5 }}
                     borderRadius="xl"
                     border="1px"
                     borderColor={themeColors.borderPrimary}
                     boxShadow="sm">
                     <Stack direction={{ base: 'column', lg: 'row' }} spacing={{ base: 4, md: 5 }} mb={4}>
                        <FormControl flex="1">
                           <FormLabel
                              fontSize={{ base: 'sm', md: 'md' }}
                              fontWeight="semibold"
                              color={themeColors.textPrimary}
                              mb={2}>
                              Select Bank
                           </FormLabel>
                           <Select
                              placeholder="Choose a bank"
                              value={selectedBank}
                              size={{ base: 'md', md: 'lg' }}
                              onChange={(e) => setSelectedBank(e.target.value)}
                              bg={themeColors.bgPrimary}
                              borderColor={themeColors.borderSecondary}
                              _hover={{ borderColor: themeColors.info }}
                              _focus={{
                                 borderColor: themeColors.info,
                                 boxShadow: `0 0 0 1px ${themeColors.info}`,
                              }}
                              borderRadius="lg">
                              {bankOptions.map((bank, index) => (
                                 <option key={`${bank.value}-${index}`} value={bank.value}>
                                    {bank.label}
                                 </option>
                              ))}
                           </Select>
                        </FormControl>

                        <FormControl flex="1">
                           <FormLabel
                              fontSize={{ base: 'sm', md: 'md' }}
                              fontWeight="semibold"
                              color={themeColors.textPrimary}
                              mb={2}>
                              Upload Bank Statement
                           </FormLabel>
                           <Input
                              type="file"
                              ref={fileInputRef}
                              onChange={handleFileSelect}
                              accept=".pdf,.csv,.xlsx,.xls"
                              size={{ base: 'md', md: 'lg' }}
                              bg={themeColors.bgPrimary}
                              borderColor={themeColors.borderSecondary}
                              _hover={{ borderColor: themeColors.info }}
                              _focus={{
                                 borderColor: themeColors.info,
                                 boxShadow: `0 0 0 1px ${themeColors.info}`,
                              }}
                              borderRadius="lg"
                              p={2}
                           />
                        </FormControl>

                        <Button
                           colorScheme="blue"
                           onClick={extractBankStatement}
                           isLoading={isLoading}
                           loadingText="Extracting..."
                           isDisabled={!selectedFile || !selectedBank}
                           alignSelf={{ base: 'stretch', lg: 'end' }}
                           size={{ base: 'md', md: 'lg' }}
                           width={{ base: 'full', lg: 'auto' }}
                           height="fit-content"
                           py={3}
                           fontWeight="semibold"
                           borderRadius="lg"
                           bg={themeColors.companyHeader}
                           _hover={{
                              transform: 'translateY(-1px)',
                              boxShadow: 'lg',
                           }}
                           _active={{ transform: 'translateY(0)' }}
                           transition="all 0.2s">
                           Extract Statements
                        </Button>
                     </Stack>

                     {message && (
                        <Alert
                           status={message.includes('Error') ? 'error' : 'success'}
                           size={{ base: 'sm', md: 'sm' }}
                           borderRadius="lg"
                           bg={message.includes('Error') ? themeColors.error : themeColors.success}
                           color="white">
                           <AlertIcon color="white" />
                           <Text fontSize={{ base: 'sm', md: 'md' }} fontWeight="medium">
                              {message}
                           </Text>
                        </Alert>
                     )}
                  </Box>

                  {/* Tabbed Bank Statements Section */}
                  {(distinctStatements.length > 0 || bankStatements.length > 0) && (
                     <Box
                        bg={themeColors.bgSecondary}
                        p={{ base: 4, md: 5 }}
                        borderRadius="xl"
                        border="1px"
                        borderColor={themeColors.borderPrimary}
                        boxShadow="sm">
                        <Tabs variant="enclosed" colorScheme="blue" size={{ base: 'sm', md: 'md' }}>
                           <TabList
                              overflowX="auto"
                              overflowY="hidden"
                              bg={themeColors.bgTertiary}
                              borderRadius="lg"
                              p={1}
                              sx={{
                                 scrollbarWidth: 'none',
                                 '&::-webkit-scrollbar': { display: 'none' },
                              }}>
                              <Tab
                                 minW="fit-content"
                                 px={{ base: 4, md: 6 }}
                                 py={3}
                                 borderRadius="md"
                                 _selected={{
                                    bg: themeColors.companyHeader,
                                    color: 'white',
                                    boxShadow: 'sm',
                                 }}
                                 fontWeight="medium"
                                 transition="all 0.2s">
                                 <HStack spacing={2}>
                                    <Text fontSize={{ base: 'sm', md: 'md' }}>All Statements</Text>
                                    {bankStatements.length > 0 && (
                                       <Badge
                                          colorScheme="green"
                                          borderRadius="full"
                                          fontSize={{ base: 'xs', md: 'sm' }}
                                          px={2}>
                                          {bankStatements.length}
                                       </Badge>
                                    )}
                                 </HStack>
                              </Tab>
                              <Tab
                                 minW="fit-content"
                                 px={{ base: 4, md: 6 }}
                                 py={3}
                                 borderRadius="md"
                                 _selected={{
                                    bg: themeColors.accountHeader,
                                    color: 'white',
                                    boxShadow: 'sm',
                                 }}
                                 fontWeight="medium"
                                 transition="all 0.2s">
                                 <HStack spacing={2}>
                                    <Text fontSize={{ base: 'sm', md: 'md' }}>Distinct Statements</Text>
                                    {distinctStatements.length > 0 && (
                                       <Badge
                                          colorScheme="blue"
                                          borderRadius="full"
                                          fontSize={{ base: 'xs', md: 'sm' }}
                                          px={2}>
                                          {distinctStatements.length}
                                       </Badge>
                                    )}
                                 </HStack>
                              </Tab>
                           </TabList>

                           <TabPanels mt={4}>
                              {/* All Bank Statements Tab */}
                              <TabPanel px={0} py={2}>
                                 {bankStatements.length > 0 && (
                                    <Box>
                                       <Stack
                                          direction={{ base: 'column', md: 'row' }}
                                          justify="space-between"
                                          align={{ base: 'stretch', md: 'center' }}
                                          mb={4}
                                          spacing={{ base: 3, md: 0 }}>
                                          <Heading
                                             size={{ base: 'sm', md: 'md' }}
                                             color={themeColors.textPrimary}
                                             fontWeight="bold">
                                             All Bank Statements ({bankStatements.length})
                                          </Heading>

                                          <Stack
                                             direction={{ base: 'column', sm: 'row' }}
                                             spacing={{ base: 3, sm: 4 }}
                                             align="stretch"
                                             width={{ base: '100%', md: 'auto' }}>
                                             <FormControl width={{ base: '100%', sm: '250px', md: '300px' }}>
                                                <FormLabel
                                                   fontSize={{ base: 'sm', md: 'md' }}
                                                   fontWeight="semibold"
                                                   color={themeColors.textPrimary}
                                                   mb={2}>
                                                   Select Daybook
                                                </FormLabel>
                                                <Select
                                                   placeholder="Choose a Daybook"
                                                   value={selectedDaybook}
                                                   size={{ base: 'md', md: 'lg' }}
                                                   onChange={(e) => setSelectedDaybook(e.target.value)}
                                                   bg={themeColors.bgPrimary}
                                                   borderColor={themeColors.borderSecondary}
                                                   _hover={{ borderColor: themeColors.info }}
                                                   _focus={{
                                                      borderColor: themeColors.info,
                                                      boxShadow: `0 0 0 1px ${themeColors.info}`,
                                                   }}
                                                   borderRadius="lg">
                                                   {daybookTypeData.map((daybook, index) => (
                                                      <option key={`${daybook.id}-${index}`} value={daybook.id}>
                                                         {daybook.name}
                                                      </option>
                                                   ))}
                                                </Select>
                                             </FormControl>

                                             <Button
                                                colorScheme="green"
                                                size={{ base: 'md', md: 'lg' }}
                                                onClick={importSelectedAllStatements}
                                                isLoading={isImporting}
                                                loadingText="Importing..."
                                                isDisabled={
                                                   Object.values(selectedAllStatements).every((v) => !v) ||
                                                   !selectedDaybook
                                                }
                                                alignSelf={{ base: 'stretch', sm: 'end' }}
                                                width={{ base: 'full', sm: 'auto' }}
                                                height="fit-content"
                                                py={3}
                                                fontWeight="semibold"
                                                borderRadius="lg"
                                                bg={themeColors.accountHeader}
                                                _hover={{
                                                   transform: 'translateY(-1px)',
                                                   boxShadow: 'lg',
                                                }}
                                                _active={{ transform: 'translateY(0)' }}
                                                transition="all 0.2s">
                                                Import Selected
                                             </Button>
                                          </Stack>
                                       </Stack>

                                       <Box
                                          border="1px"
                                          borderRadius="xl"
                                          borderColor={themeColors.borderPrimary}
                                          maxHeight={{ base: '400px', md: '500px' }}
                                          overflowX="auto"
                                          overflowY="auto"
                                          bg={themeColors.bgPrimary}
                                          boxShadow="sm">
                                          <Table
                                             size={{ base: 'sm', md: 'md' }}
                                             variant="simple"
                                             minW={{ base: '800px', md: '100%' }}>
                                             <Thead position="sticky" top={0} zIndex={1}>
                                                <Tr bg={themeColors.bgTertiary}>
                                                   <Th
                                                      width={{ base: '60px', md: '70px' }}
                                                      px={{ base: 3, md: 4 }}
                                                      borderColor={themeColors.borderSecondary}>
                                                      <VStack spacing={1} align="start">
                                                         <Checkbox
                                                            size={{ base: 'md', md: 'lg' }}
                                                            isChecked={
                                                               bankStatements.length > 0 &&
                                                               Object.values(selectedAllStatements).filter(Boolean)
                                                                  .length === bankStatements.length
                                                            }
                                                            isIndeterminate={
                                                               Object.values(selectedAllStatements).filter(Boolean)
                                                                  .length > 0 &&
                                                               Object.values(selectedAllStatements).filter(Boolean)
                                                                  .length < bankStatements.length
                                                            }
                                                            onChange={(e) => {
                                                               const isChecked = e.target.checked;
                                                               const newSelection = {};
                                                               bankStatements.forEach((_, index) => {
                                                                  newSelection[index] = isChecked;
                                                               });
                                                               setSelectedAllStatements(newSelection);
                                                            }}
                                                            colorScheme="blue"
                                                         />
                                                         <Text
                                                            fontSize={{ base: 'xs', md: 'sm' }}
                                                            color={themeColors.textTertiary}>
                                                            (
                                                            {
                                                               Object.values(selectedAllStatements).filter(Boolean)
                                                                  .length
                                                            }
                                                            )
                                                         </Text>
                                                      </VStack>
                                                   </Th>
                                                   <Th
                                                      fontSize={{ base: 'sm', md: 'md' }}
                                                      px={{ base: 3, md: 4 }}
                                                      borderColor={themeColors.borderSecondary}
                                                      color={themeColors.textPrimary}
                                                      fontWeight="bold">
                                                      Date
                                                   </Th>
                                                   <Th
                                                      fontSize={{ base: 'sm', md: 'md' }}
                                                      px={{ base: 3, md: 4 }}
                                                      borderColor={themeColors.borderSecondary}
                                                      color={themeColors.textPrimary}
                                                      fontWeight="bold">
                                                      Description
                                                   </Th>
                                                   <Th
                                                      fontSize={{ base: 'sm', md: 'md' }}
                                                      px={{ base: 3, md: 4 }}
                                                      borderColor={themeColors.borderSecondary}
                                                      color={themeColors.textPrimary}
                                                      fontWeight="bold">
                                                      Credit
                                                   </Th>
                                                   <Th
                                                      fontSize={{ base: 'sm', md: 'md' }}
                                                      px={{ base: 3, md: 4 }}
                                                      borderColor={themeColors.borderSecondary}
                                                      color={themeColors.textPrimary}
                                                      fontWeight="bold">
                                                      Debit
                                                   </Th>
                                                   <Th
                                                      fontSize={{ base: 'sm', md: 'md' }}
                                                      px={{ base: 3, md: 4 }}
                                                      borderColor={themeColors.borderSecondary}
                                                      color={themeColors.textPrimary}
                                                      fontWeight="bold">
                                                      Balance
                                                   </Th>
                                                   <Th
                                                      fontSize={{ base: 'sm', md: 'md' }}
                                                      px={{ base: 3, md: 4 }}
                                                      borderColor={themeColors.borderSecondary}
                                                      color={themeColors.textPrimary}
                                                      fontWeight="bold">
                                                      Type
                                                   </Th>
                                                </Tr>
                                             </Thead>
                                             <Tbody>
                                                {bankStatements.map((statement, index) => (
                                                   <Tr
                                                      key={index}
                                                      _hover={{ bg: themeColors.hoverBg }}
                                                      transition="background 0.2s"
                                                      borderBottom="1px"
                                                      borderColor={themeColors.borderSecondary}>
                                                      <Td px={{ base: 3, md: 4 }}>
                                                         <Checkbox
                                                            size={{ base: 'md', md: 'lg' }}
                                                            isChecked={selectedAllStatements[index] || false}
                                                            onChange={() => toggleAllStatementSelection(index)}
                                                            colorScheme="blue"
                                                         />
                                                      </Td>
                                                      <Td
                                                         fontSize={{ base: 'sm', md: 'md' }}
                                                         px={{ base: 3, md: 4 }}
                                                         whiteSpace="nowrap"
                                                         color={themeColors.textSecondary}
                                                         fontWeight="medium">
                                                         {statement.txn_date}
                                                      </Td>
                                                      <Td
                                                         maxWidth={{ base: '150px', md: '250px' }}
                                                         whiteSpace="pre-wrap"
                                                         fontSize={{ base: 'sm', md: 'md' }}
                                                         px={{ base: 3, md: 4 }}
                                                         color={themeColors.textPrimary}>
                                                         {statement.description}
                                                      </Td>
                                                      <Td
                                                         textAlign="right"
                                                         color="green.500"
                                                         fontSize={{ base: 'sm', md: 'md' }}
                                                         px={{ base: 3, md: 4 }}
                                                         fontWeight="semibold">
                                                         {statement.credit || '-'}
                                                      </Td>
                                                      <Td
                                                         textAlign="right"
                                                         color="red.500"
                                                         fontSize={{ base: 'sm', md: 'md' }}
                                                         px={{ base: 3, md: 4 }}
                                                         fontWeight="semibold">
                                                         {statement.debit || '-'}
                                                      </Td>
                                                      <Td
                                                         textAlign="right"
                                                         fontWeight="bold"
                                                         fontSize={{ base: 'sm', md: 'md' }}
                                                         px={{ base: 3, md: 4 }}
                                                         color={themeColors.textPrimary}>
                                                         {statement.balance || '-'}
                                                      </Td>
                                                      <Td px={{ base: 3, md: 4 }}>
                                                         <Badge
                                                            colorScheme={
                                                               statement.credit && parseFloat(statement.credit) > 0
                                                                  ? 'green'
                                                                  : 'red'
                                                            }
                                                            size={{ base: 'sm', md: 'md' }}
                                                            fontSize={{ base: 'xs', md: 'sm' }}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full">
                                                            {statement.credit && parseFloat(statement.credit) > 0
                                                               ? 'Credit'
                                                               : 'Debit'}
                                                         </Badge>
                                                      </Td>
                                                   </Tr>
                                                ))}
                                             </Tbody>
                                          </Table>
                                       </Box>
                                    </Box>
                                 )}
                              </TabPanel>

                              {/* Distinct Bank Statements Tab */}
                              <TabPanel px={0} py={2}>
                                 {distinctStatements.length > 0 && (
                                    <Box>
                                       <Heading
                                          size={{ base: 'sm', md: 'md' }}
                                          mb={4}
                                          color={themeColors.textPrimary}
                                          fontWeight="bold">
                                          Distinct Bank Statements ({distinctStatements.length})
                                       </Heading>

                                       <Box
                                          border="1px"
                                          borderRadius="xl"
                                          borderColor={themeColors.borderPrimary}
                                          maxHeight={{ base: '400px', md: '500px' }}
                                          overflowX="auto"
                                          overflowY="auto"
                                          bg={themeColors.bgPrimary}
                                          boxShadow="sm">
                                          <Table
                                             size={{ base: 'sm', md: 'md' }}
                                             variant="simple"
                                             minW={{ base: '600px', md: '100%' }}>
                                             <Thead position="sticky" top={0} zIndex={1}>
                                                <Tr bg={themeColors.bgTertiary}>
                                                   <Th
                                                      fontSize={{ base: 'sm', md: 'md' }}
                                                      px={{ base: 4, md: 6 }}
                                                      borderColor={themeColors.borderSecondary}
                                                      color={themeColors.textPrimary}
                                                      fontWeight="bold">
                                                      Date
                                                   </Th>
                                                   <Th
                                                      fontSize={{ base: 'sm', md: 'md' }}
                                                      px={{ base: 4, md: 6 }}
                                                      borderColor={themeColors.borderSecondary}
                                                      color={themeColors.textPrimary}
                                                      fontWeight="bold">
                                                      Description
                                                   </Th>
                                                   <Th
                                                      fontSize={{ base: 'sm', md: 'md' }}
                                                      px={{ base: 4, md: 6 }}
                                                      borderColor={themeColors.borderSecondary}
                                                      color={themeColors.textPrimary}
                                                      fontWeight="bold">
                                                      Count
                                                   </Th>
                                                </Tr>
                                             </Thead>
                                             <Tbody>
                                                {distinctStatements.map((statement, index) => (
                                                   <Tr
                                                      key={index}
                                                      _hover={{ bg: themeColors.hoverBg }}
                                                      transition="background 0.2s"
                                                      borderBottom="1px"
                                                      borderColor={themeColors.borderSecondary}>
                                                      <Td
                                                         fontSize={{ base: 'sm', md: 'md' }}
                                                         px={{ base: 4, md: 6 }}
                                                         whiteSpace="nowrap"
                                                         color={themeColors.textSecondary}
                                                         fontWeight="medium">
                                                         {statement.txn_date}
                                                      </Td>
                                                      <Td
                                                         maxWidth={{ base: '200px', md: '300px' }}
                                                         whiteSpace="pre-wrap"
                                                         fontSize={{ base: 'sm', md: 'md' }}
                                                         px={{ base: 4, md: 6 }}
                                                         color={themeColors.textPrimary}>
                                                         {statement.description}
                                                      </Td>
                                                      <Td textAlign="center" px={{ base: 4, md: 6 }}>
                                                         <Badge
                                                            colorScheme="blue"
                                                            borderRadius="full"
                                                            fontSize={{ base: 'sm', md: 'md' }}
                                                            px={3}
                                                            py={1}
                                                            bg={themeColors.companyHeader}
                                                            color="white">
                                                            {statement.count}
                                                         </Badge>
                                                      </Td>
                                                   </Tr>
                                                ))}
                                             </Tbody>
                                          </Table>
                                       </Box>
                                    </Box>
                                 )}
                              </TabPanel>
                           </TabPanels>
                        </Tabs>
                     </Box>
                  )}

                  <Divider borderColor={themeColors.borderSecondary} />
               </VStack>
            </ModalBody>

            <ModalFooter
               justifyContent={{ base: 'stretch', md: 'flex-end' }}
               px={{ base: 4, md: 6 }}
               py={{ base: 4, md: 5 }}
               bg={themeColors.bgSecondary}
               borderTop="1px"
               borderColor={themeColors.borderPrimary}>
               <Stack
                  direction={{ base: 'column-reverse', sm: 'row' }}
                  spacing={{ base: 3, sm: 3 }}
                  width={{ base: '100%', md: 'auto' }}>
                  <Button
                     size={{ base: 'md', md: 'lg' }}
                     onClick={onClose}
                     width={{ base: '100%', sm: 'auto' }}
                     variant="outline"
                     borderColor={themeColors.borderSecondary}
                     color={themeColors.textSecondary}
                     _hover={{
                        bg: themeColors.hoverBg,
                        borderColor: themeColors.textTertiary,
                     }}
                     borderRadius="lg"
                     fontWeight="medium">
                     Close
                  </Button>
                  <Button
                     colorScheme="green"
                     size={{ base: 'md', md: 'lg' }}
                     onClick={importSelectedAllStatements}
                     isLoading={isImporting}
                     loadingText="Importing..."
                     isDisabled={Object.values(selectedAllStatements).every((v) => !v) || !selectedDaybook}
                     width={{ base: '100%', sm: 'auto' }}
                     bg={themeColors.accountHeader}
                     _hover={{
                        transform: 'translateY(-1px)',
                        boxShadow: 'lg',
                     }}
                     _active={{ transform: 'translateY(0)' }}
                     transition="all 0.2s"
                     borderRadius="lg"
                     fontWeight="semibold">
                     Import Selected
                  </Button>
               </Stack>
            </ModalFooter>
         </ModalContent>

         <AddEditForm
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            isEditMode={isEditMode}
            currentRow={currentRow}
            initialData={currentRow}
            parentGlGroup={31}
            onSave={handleSave}
            demoname={'SUSPENCE'}
            formType="Account"
            saveandcontinue={false}
         />
      </Modal>
   );
}
